import { HotelCardStarsPropertiesType } from "@website/accommodation-ui/hotel-card-new/hotel-card-stars/hotel-card-stars.types";
import { MaterialIcon } from "@website/icons/material";
import { useMemo } from "react";

export const useHotelCardStars = (properties: HotelCardStarsPropertiesType) => {
  const { stars, color, starSize = "small" } = properties;

  const hotelStars = useMemo(
    () =>
      Array.from({ length: stars }, (_: number, index: number) => (
        <MaterialIcon
          className={`${
            starSize === "large"
              ? "text-subtitle-1"
              : starSize === "medium"
                ? "!text-[24px]"
                : "text-xs"
          } ${
            color === "neutral"
              ? "text-on-surface-medium-emphasis"
              : "text-on-surface-high-emphasis"
          }`}
          key={`star-${index}`}
          name="star"
        />
      )),
    [color, starSize, stars]
  );
  return { hotelStars };
};
